import React, {useCallback, useEffect, useState} from 'react';
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import BlueButton from "./BlueButton/BlueButton.js";
import '../assets/css/multiselect.css';
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 800 ? 800 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '80vh'
};

function MultiSelectCustom({setFilter,setOpen, open, options, selected, setSelected}) {

    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate()

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };


    const handleToggleSelect = (option) => {
        let newSelected;
        if (selected.find(item => item.value === option.value)) {
            newSelected = selected.filter(item => item.value !== option.value);
        } else {
            newSelected = [...selected, option];
        }

        setSelected(newSelected);

        // Save to filter state
        setFilter(prev => ({
            ...prev,
            [open]: newSelected.map(s => s.value).join(','),
            page: 1
        }));

        // Save to URL (immediate navigation)
        const newQuery = {...query};
        newQuery[open] = newSelected.map(s => s.value).join(',');
        newQuery.page = 1;

        navigate(`?${qs.stringify(newQuery, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    };

    const handleSelectAll = () => {
        setSelected(options);
    };

    const handleClearAll = () => {
        setSelected([]);
        query[open] = ''
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    };

    const handleClear = (option) => {
        setSelected(prev => prev.filter(item => item.value !== option.value));
    };

    const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSave = () => {
        const newQuery = {...query};
        newQuery[open] = selected.map(s => s.value).join(',');
        newQuery.page = 1;
        navigate(`?${qs.stringify(newQuery, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
        setOpen('');
    };
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={!!open}
            onClose={() => setOpen('')}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="d-flex flex-column">
                        <div className="d-flex">
                            <div className="w-50">
                                <input
                                    className="search-bar-select w-100"
                                    type="text"
                                    placeholder="Որոնել..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className="w-50">
                                <div className="search-bar-select w-100">
                                    <span>{selected.length ? selected.length + ' Ընտրված' : 'Ընտրված տվյալներ չկան'}</span>
                                    {selected.length ?
                                        <span className="clear" onClick={handleClearAll}>Մաքրել</span> : null}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex multi_body">
                            <div>
                                <div className="options-list">
                                    {filteredOptions.length === 0 ? (
                                        <p style={{padding: 10}}>Տվյալներ չկան...</p>
                                    ) : (
                                        filteredOptions.map((option) => (
                                            <div key={option.value} className="option">
                                                <label
                                                    className={selected.find(o => o.value === option.value) ? 'selected' : ''}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selected.find(o => o.value === option.value) || false}
                                                        onChange={() => handleToggleSelect(option)}
                                                    />
                                                    <span>
                                                       <span className="single-line">{option.label}</span>
                                                    </span>
                                                </label>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                            <div className="select_part">
                                {selected.map((option) => (
                                    <div key={option.value} className="select_option d-flex justify-content-between">
                                        <span>{option.label}</span>
                                        <i className="fas fa-times" style={{color: '#ccc'}}
                                           onClick={() => handleClear(option)}/>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <hr/>

                        <div className="button-cont">
                            <BlueButton title="Հաստատել"
                                        buttonStyle={"blue-button"}
                                        onChangeValue={handleSave}/>
                        </div>

                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default MultiSelectCustom;